<template>
    <div class="keyword_box">
        <div class="key_topTit">Discounts</div>

        <div class="discount-container">
            <div class="discount-btn-container d-flex justify-content-between align-items-center">
                <el-button type="peiso-primary-pink" class="" @click="openDiscount()">Create New Discount</el-button>
                <el-input v-model="search" class="peiso-input-default" style="max-width: 300px;" placeholder="Search discount"></el-input>
            </div>

            <div class="table-wrp">
                <el-table :data="tableData" class="discount_list w-100">
                    <el-table-column prop="code" align="center" label="CODE" width="150">
                    </el-table-column>

                    <el-table-column prop="discount_type" align="center" label="DISCOUNT TYPE" width="180">
                    </el-table-column>
                    
                    <el-table-column prop="discount" align="center" label="DISCOUNT" width="120">
                    </el-table-column>

                    <el-table-column prop="validity" align="center" label="VALIDITY" width="120">
                    </el-table-column>

                    <el-table-column prop="remarks" align="center" label="REMARKS" width="200">
                    </el-table-column>

                    <el-table-column prop="discount_comments" align="center" label="COMMENTS" min-width="350">
                        <template #default="scope">
                            <div v-if="scope.row.discount_comments.length" class="discount-comments-wrapper d-flex flex-column gap-5 ">
                                <span class="text-left name">
                                    {{ `${scope.row.discount_comments[0].commentName} commented: ` }}
                                    <span class="text-left content">{{ scope.row.discount_comments[0].commentContent }}</span>
                                </span>
                                
                                <span class="text-right date">{{ scope.row.discount_comments[0].commentDate }}</span>
                            </div>

                            <div v-if="!scope.row.discount_comments.length" class="no-comment d-flex align-items-center justify-content-center">
                                <span>
                                    No comment displayed.
                                </span>
                            </div>

                            <!-- <div class="button-comment d-flex align-items-center justify-content-center w-100 gap-10">
                                <div class="comment d-flex align-items-center gap-5" @click="viewSelectedComments(scope.row)">
                                    <img src="@/assets/comment.svg" alt=""> 
                                    <span>Comment</span>
                                </div>
                                <div class="comment" v-if="scope.row.discount_comments.length > 1">
                                    <span>View all comments</span>
                                </div>
                            </div> -->
                        </template>
                    </el-table-column>

                    <el-table-column prop="discount_venues" align="center" min-width="250" label="DISCOUNTED VENUES">
                        <template #default="scope">
                            <div class="discount-venue-container d-flex flex-wrap gap-10">
                                <div class="discount-venue-wrapper text-nowrap" v-for="(item, i) in scope.row.discount_venues">
                                    {{ item.venueName }}
                                    <!-- <div class="discount-remove cursor-pointer">
                                        <img src="@/assets/close.svg" alt="">
                                    </div> -->
                                </div>
                            </div>
                        </template>
                    </el-table-column>

                    <!-- <el-table-column prop="status" align="center" width="120">
                        <template #header>
                            <div class="status position-relative w-100">
                                STATUS
                                <span class="d-block">
                                    (ENABLE)
                                </span>
                            </div>
                        </template>
                    </el-table-column> -->
                    
                    <el-table-column prop="action" align="center" label="ACTION" width="240">
                        <template #default="scope">
                            <div class="d-flex">
                                <el-button type="peiso-primary-pink action" @click="showInfo(scope.row)">UPDATE</el-button>
                                <el-button type="peiso-danger action" @click="showEnableDisableDiscount(scope.row)">DELETE</el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-container d-flex justify-content-center m-bottom-3rem">
                    
                    <el-pagination
                    
                        class="my_pageSel"
                        layout="prev, pager, next"
                        :page-size="pageSize"
                        :current-page.sync="page"
                        @current-change="changePage"
                        :total="pageTotal">
                    </el-pagination>
                    <!-- @current-change="" -->
                </div>

            </div>
        </div>

        <el-dialog title="Add Discount" class="peiso-dialog-box" :visible.sync="isOpenDiscount" :modal-append-to-body="false"
            :show-close="false" :close-on-click-modal="false" width="840px" center>
            
            <div class="discount-entry-container">
                <div class="discount-entry-wrapper">
                    <span class="d-block">
                        Discount Code:
                    </span>

                    <el-input v-model="code" placeholder="" class="peiso-input-default w-100" :class="{'is-invalid' : code == ''}"></el-input>
                </div>
            </div>

            <div class="discount-entry-container d-flex gap-16">
                <div class="discount-entry-wrapper w-100">
                    <span class="d-block">
                        Discount Type:
                    </span>

                    <!-- <el-input v-model="discountType" placeholder="" class="peiso-input-default w-100"></el-input> -->
                    <el-select v-model="discountType" class="peiso-select-default w-100" :class="{'is-invalid' : discountType == ''}">
                        <el-option :value="'Fixed Amount'">Fixed Amount</el-option>
                        <el-option :value="'Free Trial'">Free Trial</el-option>
                        <el-option :value="'Percentage'">Percentage</el-option>
                    </el-select>
                </div>

                <div class="discount-entry-wrapper w-100">
                    <span class="d-block">
                        Discount:
                    </span>

                    <el-input type="number" v-model="discount" placeholder="" class="peiso-input-default w-100" :class="{'is-invalid' : discount == ''}"></el-input>
                </div>

                <div class="discount-entry-wrapper w-100">
                    <span class="d-block">
                        Validity:
                    </span>

                    <el-input type="number" v-model="validity" placeholder="" class="peiso-input-default w-100" :class="{'is-invalid' : validity == ''}"></el-input>
                    
                </div>
            </div>

            <div class="discount-entry-container">
                <div class="discount-entry-wrapper">
                    <span class="d-block">
                        Remarks:
                    </span>

                    <el-input v-model="remarks" placeholder="" maxlength="50" class="peiso-input-default w-100"></el-input>

                    <div class="d-flex justify-content-end">
                        <span class="remarks-length">
                            {{ `${remarks.length} / 50` }}
                        </span>
                    </div>
                    
                </div>
            </div>

            <div class="discount-entry-container discount-button d-flex justify-content-center w-100">
                <el-button class="w-100" @click="handleClose">Cancel</el-button>
                <el-button v-if="!isLoading && !isUpdate" class="w-100" type="peiso-primary-pink" @click="createDiscount()">Confirm</el-button>
                <el-button v-if="!isLoading && isUpdate" class="w-100" type="peiso-primary-pink" @click="updateDiscount()">Update</el-button>
                <el-button v-if="isLoading" class="w-100" type="peiso-primary-pink cursor-disable" :disabled="true">{{ isUpdate ? 'Updating...' : 'Saving...' }}</el-button>
            </div>
        </el-dialog>

        <message-alert :title="`Do you want to delete selected discount?`" :isActivate="1" :btnLabel="'Disable'" :btnLabelLoading="'Disabling...'" :show="isOpenDisableMessage" @close="isOpenDisableMessage = false" :isLoadingMessage="isLoadingMessage" @handleTrigger="deleteDiscount()"></message-alert>

        <el-dialog title="Comments" class="peiso-dialog-box" :visible.sync="isOpenComment" :modal-append-to-body="false"
            :show-close="false" :close-on-click-modal="false" width="840px" center>
            
            <div class="discount-comment-container d-flex flex-column gap-16">
                <div class="discount-container comment-container d-flex flex-column" :class="{'justify-content-center align-items-center' : selectedDiscount.discount_comments && !selectedDiscount.discount_comments.length}">
                    <div v-if="selectedDiscount.discount_comments && selectedDiscount.discount_comments.length" class="discount-comments-wrapper d-flex flex-column gap-10 " v-for="(comment, i) in selectedDiscount.discount_comments" :key="`comment-${i}`">
                        <span class="text-left name">
                            {{ `${comment.commentName}` }}
                            <span class="d-block text-left content">{{ comment.commentContent }}</span>
                        </span>
                        
                        <span class="text-right date">{{ comment.commentDate }}</span>
                    </div>
                    
                    <span v-if="selectedDiscount.discount_comments && !selectedDiscount.discount_comments.length">No comment displayed</span>
                </div>
                <div class="comment-field d-flex gap-16">
                    <el-input v-model="comment" placeholder="" class="peiso-input-default w-100" placeholder="Leave a comment here..."></el-input>
                    <el-button type="peiso-primary-pink" :class="{'cursor-disable' : comment == ''}">Comment</el-button>
                </div>
            </div>
        </el-dialog>
    </div>
</template>

<style lang='scss' >
@import 'static/scss/colors';
@import 'static/scss/fonts/fonts';
@import '@/common/scrollbar.scss';
    .discount-container {
        .el-button--peiso-primary-pink {
            font-size: 24px;
            height: 60px;
            width: 280px;
            &.action {
                @include montserrat-font(16px, normal, 400, $pink1) {
                    height: 40px;
                    width: 100% !important;
                    padding: 0px;
                }

                &:hover {
                    color: $white;
                }
            }
        }

        .el-button--peiso-danger {
            &.action {
                @include montserrat-font(16px, normal, 400, $red-hover) {
                    height: 40px;
                    width: 100% !important;
                    padding: 0px;
                    color: $white;
                }
            }
        }

        .table-wrp {
            margin-top: 30px;
            min-height: 200px;
            width: 100%; 
            .status {
                > span {
                    font-size: 12px;
                }
            }

        }

        .discount_list {
            font-family: 'Montserrat', sans-serif !important;
            border: 1px solid $gray6;
            .el-table__row {
                height: 70px;
                > .el-table__cell {
                    padding: 0px;
                    min-height: 70px;
                    border: 1px solid $gray6;
                    > .cell {
                        font-size: 16px !important;
                    }
                }
                
            }

            .el-table__header {
                .el-table__cell {
                    
                    border: 1px solid $gray6 !important;
                }
            }
        }

        .discount-venue-container {
            padding: 10px 0px;
            .discount-venue-wrapper {

                @include montserrat-font(12px, normal, 400, $white) {
                    position: relative;
                    background-color: $gray2;
                    border-radius: 20px;
                    padding: 8px 1rem;
                    margin-top: 6px;
                }

                .discount-remove {
                    position: absolute;
                    top: -10px;
                    right: 0px;
                    z-index: 6;
                }


            }
        }

        .discount-comments-wrapper {
            padding: 10px;
            border-radius: 7px;
            background-color: $gray2;
            margin: 10px 0px;
            .name {
                font-size: 14px;
                font-weight: 500;
            }
            .content {
                font-size: 13px;
            }

            .date {
                font-size: 12px;
            }
        }

        .no-comment {
            margin: 2rem 0;
            font-size: 16px;
            color: $gray8;
            
        }

        .button-comment {
            font-size: 14px;
            color: $gray8;
            cursor: pointer;
            margin-bottom: 10px;
            .comment {
                padding: 5px 10px;
                transition: 0.3s;
                border-radius: 5px;
                &:hover {
                    background-color: $gray9;
                }
            }
        }


    }

    
    .discount-entry-container {
        margin-bottom: 1rem;
        .discount-entry-wrapper {
            color: $white;
            font-size: 16px;
            span {
                margin-bottom: 10px;
            }

            .remarks-length {
                margin-top: 10px !important;
                font-size: 12px !important;
                font-weight: 400 !important;
            }
        }

        &.discount-button {
            gap: 2rem;
            .el-button {
                font-family: 'Montserrat', sans-serif !important;
                background-color: transparent;
                max-width: 300px;
                
                &--peiso-primary-pink {
                    font-size: 24px;
                    color: $pink1;

                }
    
                &--default {
                    color: $white;
                    font-size: 24px;
                }
            }
        }
    } 
    .comment-container {
        min-height: 300px;
        max-height: 500px;
        overflow: hidden scroll;
        padding: 0 1rem;
        &::-webkit-scrollbar {
            @extend .scrollbar;
        }

        &::-webkit-scrollbar-track {
            // @extend .scrollbar-track;
            background: transparent
        }

        &::-webkit-scrollbar-thumb {
            @extend .scrollbar-thumb;
        }
        .discount-comments-wrapper {
            background-color: $dark-blue !important;
            color: $white;
        }
    }
</style>

<script>
import messageAlert from '@/components/modal/messageAlert';
import discount from '@/api/discount'
import utils from '@/utils/utils';

    export default {
        data() {
            return {
                tableData: [
                    // {
                    //     code: 'DOSHIIPROMO',
                    //     discount_type: 'FIXED AMOUNT',
                    //     discount: '$50.00',
                    //     validity: '10',
                    //     remarks: 'Fixed amount for k-series user good for 90 days $50 off.',
                    //     discount_venues: [
                    //         'Assembly the peoples pub', 'Busta Manly', 'GPO', 'Cantina', 'Belles Circular Quay', 'Bayswater Hotel'
                    //     ],
                    //     status: 'ENABLE',
                    //     action: 'DISABLE'
                    // },
                    
                    // {
                    //     code: 'DOSHIIPROMO',
                    //     discount_type: 'PERCENTAGE',
                    //     discount: '20%',
                    //     validity: '10',
                    //     remarks: 'Fixed amount for k-series user good for 90 days $50 off.',
                    //     discount_venues: [
                    //         'CHOW! A Taste of South East Asia', 'Conti - Beach Road', 'Country Club Hotel Yea'
                    //     ],
                    //     status: 'ENABLE',
                    //     action: 'DISABLE'
                    // }
                ],
                isOpenDiscount: false,
                code: '',
                discountType: 'Percentage',
                discount: '',
                validity: '',
                remarks: '',
                isOpenDisableMessage: false,
                isLoadingMessage: '',
                isLoading: false,
                selected: {},
                isUpdate: 0,
                isEnableDiscount: process.env.IS_ENABLE_DISCOUNT == '1' ? true : false,
                isOpenComment: false,
                comment: '',
                selectedDiscount: {},
                discountData: {},
                page: 1,
                pageSize: 10,
                pageTotal: 50,
                search: ''
            }   
        },
        props: {
            
        },
        components: {
            messageAlert: messageAlert
        },
        watch: {
            
        },
        computed: {
        },
        methods: {
            showInfo(data) {
                this.selected = data
                this.code = data.code
                this.discountType = data.discount_type
                this.discount = data.discount
                this.validity = data.validity
                this.remarks = data.remarks ? data.remarks : ''
                this.isOpenDiscount = true
                this.isUpdate = 1
            },

            openDiscount() {
                this.isOpenDiscount = true
                this.isUpdate = 0
            },
            showEnableDisableDiscount(data) {
                this.selected = data
                this.isOpenDisableMessage = true
            },

            triggerEnableDisableDiscount() {
                this.isLoadingMessage = true

                // discount

                setTimeout(() => {
                    this.isLoadingMessage = false
                    this.isOpenDisableMessage = false
                }, 2000);

            },

            handleClose() {
                this.isOpenDiscount = false
            },

            async createDiscount() {
                var amount = parseInt(this.discount) ? parseInt(this.discount) : 0
                var validity = parseInt(this.validity) ? parseInt(this.validity) : 0
                var disType = 'percent';
                if (this.code == '') {
                    utils.alert('', 'Discount code is required but missing.', 'error')
                    return
                } else if (amount <= 0) {
                    utils.alert('', 'Discount is required but missing and must be greater than to zero.', 'error')
                    return
                } else if (validity <= 0) {
                    utils.alert('', 'Validity is required but missing and must be greater than to zero.', 'error')
                    return
                }
                this.isLoading = true
                if (this.discountType == 'Fixed Amount') {
                    disType = 'fixed'
                } else if (this.discountType == 'Free Trial') {
                    disType = 'trial'
                }
                var payload = {
                    code: this.code,
                    type:  disType,
                    value: amount,
                    validity_in_days: validity,
                    remarks: this.remarks
                }

                const res = await discount.createDiscount(payload)

                if (res.data.code == 0) {
                    utils.alert('', 'Discount successfully added', 'success')
                    this.isOpenDiscount = false
                } else {
                    utils.alert('Error', res.data.message, 'error')
                }
                this.isLoading = false
                this.getDiscountList()
            },

            async updateDiscount() {
                var amount = parseInt(this.discount) ? parseInt(this.discount) : 0
                var validity = parseInt(this.validity) ? parseInt(this.validity) : 0
                var disType = 'percent';
                if (this.code == '') {
                    utils.alert('', 'Discount code is required but missing.', 'error')
                    return
                } else if (amount <= 0) {
                    utils.alert('', 'Discount is required but missing and must be greater than to zero.', 'error')
                    return
                } else if (validity <= 0) {
                    utils.alert('', 'Validity is required but missing and must be greater than to zero.', 'error')
                    return
                }
                this.isLoading = true
                if (this.discountType == 'Fixed Amount') {
                    disType = 'fixed'
                } else if (this.discountType == 'Free Trial') {
                    disType = 'trial'
                }
                var payload = {
                    code: this.code,
                    type: disType,
                    value: amount,
                    validity_in_days: validity,
                    remarks: this.remarks
                }

                const res = await discount.updateDiscount(this.selected.code, payload)

                if (res.data.code == 0) {
                    utils.alert('', 'Discount successfully updateds', 'success')
                    this.isOpenDiscount = false
                } else {
                    utils.alert('Error', res.data.message, 'error')
                }
                this.isLoading = false
                this.getDiscountList()
            },

            async deleteDiscount() {
                this.isLoadingMessage = true

                const res = await discount.deleteDiscount(this.selected.code)

                if (res.data.code == 0) {
                    utils.alert('', 'Discount successfully deleted', 'success')
                } else {
                    utils.alert('Error', res.data.message, 'error')
                }
                
                this.isLoadingMessage = false
                this.isOpenDisableMessage = false
                this.getDiscountList()
                
            },

            getDiscountList(pageNum = 1, pageSize = 10) {
                var payloads = {
                    pageNum: pageNum,
                    pageSize: pageSize
                }
                var discounts = []
                discount.getDiscountList(payloads).then((res) => {
                    var data = res.data
                    this.discountData = data.data
                    this.pageTotal = data.data.total
                
                    if (res.data.code == 0) {
                        if (data.data.list.length) {
                            var list = data.data.list.map((n) => {
                                var dis = n.discounts
                                var venue = n.venueList
                                var disType = 'Percentage'
                                
                                if ( dis.type == 'fixed') {
                                    disType = 'Fixed Amount'
                                } else if ( dis.type == 'trial') {
                                    disType = 'Free Trial'
                                }
                                var discounts = {
                                    code: dis.code,
                                    discount_type: disType,
                                    discount: dis.value,
                                    validity: dis.validityInDays,
                                    remarks: dis.remarks,
                                }

                                var final = discounts

                                final.discount_venues = venue

                                final.discount_comments = [
                                    // {
                                    //     commentName: 'Ivan',
                                    //     commentContent: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry.',
                                    //     commentDate: '2024-04-09 18:31:00'
                                    // },
                                    // {
                                    //     commentName: 'Cali',
                                    //     commentContent: 'ply dummy text of the printing and typesetting industry.',
                                    //     commentDate: '2024-04-09 18:59:00'
                                    // },
                                    // {
                                    //     commentName: 'Dan',
                                    //     commentContent: 'ge when looking at its layout. The point of using Lorem Ipsum is that it has a mo.',
                                    //     commentDate: '2024-04-09 18:59:00'
                                    // }

                                ]

                                return final
                            })
                            this.tableData = list

                       }
                        
                    }
                })

            },
            
            viewSelectedComments(data) {
                this.pageSize 
                this.isOpenComment = true
                this.selectedDiscount = data
            },

            changePage(e) {
                console.log(e)
                this.page = e
                this.getDiscountList(this.page, this.pageSize)
            }   

        },
        mounted() {
            if (!this.isEnableDiscount) {
                this.$router.replace('/setting')
                
            }

            this.getDiscountList(this.page, this.pageSize)
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/discount/index.vue